// extracted by mini-css-extract-plugin
export var btnPrimary = "modal_btnPrimary__b9N3+";
export var btnPrimaryOutline = "modal_btnPrimaryOutline__0xPnZ";
export var buttons = "modal_buttons__XUh5S";
export var close = "modal_close__PDLph";
export var container = "modal_container__YWMZ1";
export var content = "modal_content__ARFeb";
export var header = "modal_header__5GM86";
export var isTransactionError = "modal_isTransactionError__GTCx7";
export var modal = "modal_modal__RWQmB";
export var subtitle = "modal_subtitle__KIDnX";
export var title = "modal_title__B+Ltu";